import { useState } from "react";
import TestimonialBrowse from "./TestimonialBrowse";
import classNames from "classnames";
import { useSelector } from "react-redux";

function Testimonials({ className }) {
  const { testimonialsData } = useSelector((store) => store.app);
  const testimonialCount = testimonialsData.length;
  const [activeIndex, setActiveIndex] = useState(
    Math.floor(testimonialCount / 2)
  );
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe && activeIndex !== testimonialCount - 1) {
      setActiveIndex((activeIndex + 1 + testimonialCount) % testimonialCount);
    } else if (isRightSwipe && activeIndex > 0) {
      setActiveIndex((activeIndex - 1 + testimonialCount) % testimonialCount);
    }
  };

  if (testimonialCount > 5) {
    throw Error("Cannot have more than 5 testimonials.");
  }

  const testimonialDivs = testimonialsData.map((testimonial, index) => (
    <div
      className="flex flex-col h-max w-full absolute"
      key={testimonial.id}
      style={{
        left: `${index * 106}%`,
      }}
    >
      <div className="flex flex-row items-center mb-7 font-medium">
        <img
          src={testimonial.pic}
          alt={testimonial.name}
          className="rounded-full w-[70px] h-auto"
        />
        <div className="flex flex-col pl-3">
          <p className="text-2xl">{testimonial.name}</p>
          <p>{testimonial.desgn}</p>
        </div>
      </div>
      <div
        className="overflow-y-auto pr-1 h-max"
        onWheelCapture={(e) => e.stopPropagation()}
      >
        <p className="testimonial-text mb-2.5 h-max">{testimonial.text}</p>
        {testimonial.link && (
          <a
            href={testimonial.link}
            target="_blank"
            rel="noreferrer"
            className="testimonial-link"
            // FIXME: The below listener causes issues when we go from the 1st to 2nd testimonial via tab key when there are a total of 3 testimonials.
            /**
             * The following is to auto scroll the testimonials to the currently focussed
             * "full text" in case the user is using the Tab key for navigating the website.
             */
            onFocus={() => setActiveIndex(index)}
          >
            Full Text
          </a>
        )}
      </div>
    </div>
  ));

  return (
    <div
      className={classNames(
        "w-[430px] h-max testimonial-container px-4 pt-4 text-white flex flex-col overflow-hidden",
        className
      )}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div
        className="w-full h-[300px] flex flex-row relative mt-1 mb-4"
        style={{
          transform: `translate(calc(${activeIndex} * -106%))`,
          transition: "transform 0.3s linear",
        }}
      >
        {testimonialDivs}
      </div>
      <TestimonialBrowse
        onOffset={(offset) =>
          setActiveIndex(
            (activeIndex + offset + testimonialCount) % testimonialCount
          )
        }
        numberOfCircles={testimonialCount}
        activeCircle={activeIndex}
      />
    </div>
  );
}

export default Testimonials;
